var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            width: "480px",
            "show-close": !_vm.isTypeName.includes(_vm.typeName),
            "close-on-click-modal": !_vm.isTypeName.includes(_vm.typeName),
            visible: _vm.isTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isTitle = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "titleDialog",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_c("p", [_vm._v("考生须知")]), _c("i")]
          ),
          _c("div", { staticClass: "isTitleText" }, [
            _c("p", [
              _c("i", { staticClass: "iconfont icontishi" }),
              _vm._v(_vm._s(_vm.mainText)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.describeText))]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.isTypeName.includes(_vm.typeName)
                ? _c(
                    "el-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          _vm.isTitle = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.isRouterReturn()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.typeName === "submit" ? "确定提交" : "确 定")
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }